# frozen_string_literal: true

module Engine
  module Game
    module G1888
    end
  end
end
